import { FilingType } from '../../../../../graphql';
import {
  Offering_OfferingHeader_OfferingFilingsPartsFragment,
  Offering_OfferingHeader_OfferingTermsPartsFragment,
} from '../../../graphql';

type OfferingFiling = Offering_OfferingHeader_OfferingFilingsPartsFragment;

type FilingsByType = {
  [FilingType.Final]?: OfferingFiling[];
  [FilingType.Revised]?: OfferingFiling[];
  [FilingType.Initial]?: OfferingFiling[];
};

export type Filings = Offering_OfferingHeader_OfferingTermsPartsFragment['filings'];

export function getLatestFilingsPrices(filings?: Filings) {
  const filingsByType: FilingsByType = {};
  for (const filing of filings || []) {
    filingsByType[filing.filingType] ??= [];
    filingsByType[filing.filingType]?.unshift(filing);
  }

  const sortedLatestFilings = [
    filingsByType?.[FilingType.Final],
    filingsByType?.[FilingType.Revised],
    filingsByType?.[FilingType.Initial],
  ].flat();

  return {
    ipoRangeLow: sortedLatestFilings.find(filling => !!filling?.ipoRangeLow)?.ipoRangeLow,
    ipoRangeHigh: sortedLatestFilings.find(filling => !!filling?.ipoRangeHigh)?.ipoRangeHigh,
    offerPrice: sortedLatestFilings.find(filling => !!filling?.offerPrice)?.offerPrice,
  };
}
